import data from '@emoji-mart/data';
import {init as initEmojiMart} from 'emoji-mart';
import {lazyRender} from './utils/lazy-render';

const mountTargets = [
  [
    '#register-account-mount-point',
    () => import('./apps/register-account/App').then(module => module.default),
  ],

  [
    '[data-share-sheet]',
    () =>
      import('./components/ShareSheet/ShareSheet').then(
        module => module.default,
      ),
  ],

  [
    '[data-practice-social-links]',
    () =>
      import('./components/PracticeSocialLinks').then(module => module.default),
  ],

  [
    '#notification_preferences_app',
    () =>
      import(
        './components/NotificationsEditor/NotificationsEditorContainer'
      ).then(module => module.default),
  ],
  [
    '#recognition_preferences_app',
    () =>
      import('./components/PrivacyPreferences').then(module => module.default),
  ],
  [
    '#theme_selector_app',
    () => import('./components/ThemeSelector').then(module => module.default),
  ],

  [
    '#points_nav_icon_app',
    () =>
      import('./components/PointsNavigationIcon').then(
        module => module.default,
      ),
  ],

  [
    '#return-icon',
    () =>
      import('@practicegenius/pg-ui/src/icons/ReturnIcon').then(
        module => module.ReturnIcon,
      ),
  ],

  [
    '#points_banner_app',
    () =>
      import('./components/PointsProgressBannerWithPhpJs').then(
        module => module.default,
      ),
  ],

  [
    '#profile_user_info_app',
    () =>
      import('./components/ProfileUserInfo/ProfileUserInfo').then(
        module => module.default,
      ),
  ],

  [
    '#redemption_auth_challenge_app',
    () =>
      import('./components/Redemption/RedemptionAuthChallenge').then(
        module => module.default,
      ),
  ],
  ['#home_app', () => import('./apps/home/App').then(module => module.default)],
  [
    '#promotions_microsite',
    () => import('./apps/promotions/index').then(module => module.default),
  ],
  [
    '#promotion_landing_page',
    () =>
      import('./apps/promotions/components/LandingPage').then(
        module => module.default,
      ),
  ],
  [
    '#promotion_preview',
    () =>
      import('./apps/promotions/components/Preview').then(
        module => module.default,
      ),
  ],
  [
    '#promotion_preview_confirmation',
    () =>
      import('./apps/promotions/components/PreviewConfirmation').then(
        module => module.default,
      ),
  ],
  [
    '#user_notification_dialog_root',
    () =>
      import('./components/UserNotificationDialog').then(
        module => module.UserNotificationDialog,
      ),
  ],
  [
    '#promotion_preview_signup_form',
    () =>
      import('./apps/promotions/components/PreviewSignUpForm').then(
        module => module.default,
      ),
  ],
  [
    '#points_app',
    () => import('./apps/earn-points/index').then(module => module.default),
  ],
  [
    '#global_users_events',
    () =>
      import('./components/GlobalUsersEvents').then(module => module.default),
  ],
  [
    '#most_popular_prizes',
    () =>
      import('./apps/earn-points/components/PopularPrizes').then(
        module => module.PopularPrizesFreestanding,
      ),
  ],
  [
    '#recognitions_app',
    () => import('./apps/recognitions/index').then(module => module.default),
  ],
  [
    '#posts_app',
    () => import('./apps/posts/index').then(module => module.default),
  ],
  [
    '#dashboard_activity_loop_invitations',
    () =>
      import(
        './apps/activity-loops/SitesDashboardActivityLoopInvitations'
      ).then(module => module.default),
  ],
  [
    '#dashboard_recurring_activities',
    () =>
      import('./apps/activity-loops/SitesDashboardRecurringActivityLoops').then(
        module => module.default,
      ),
  ],
  [
    '#dashboard_recognitions',
    () =>
      import('./apps/recognitions/SitesDashboardRecognitions').then(
        module => module.default,
      ),
  ],
  [
    '#dashboard_points_recognitions',
    () =>
      import('./apps/recognitions/SitesDashboardPointsRecognitions').then(
        module => module.default,
      ),
  ],
  [
    '#dashboard_highlighted_promotion',
    () =>
      import('./apps/promotions/SitesDashboardHighlightedPromotion').then(
        module => module.default,
      ),
  ],
  [
    '#milestones_app',
    () =>
      import('./apps/milestones/SitesMilestonesApp').then(
        module => module.default,
      ),
  ],
  [
    '#documents_app',
    () => import('./apps/documents/index').then(module => module.default),
  ],
  [
    '#register_global_mobile_app_events_for_authenticated_user',
    () =>
      import(
        './shared/hooks/useRegisterGlobalMobileAppEventsForAuthenticatedUser'
      ).then(module => module.default),
  ],
  [
    '#places_app',
    () => import('./apps/places/index').then(module => module.default),
  ],
];

let lastRenderedPage = '';

function lazyMount() {
  /**
   * Don't reprocess react mount points more than once per page load. This causes some
   *   very strange behavior when using browser navigation
   * @see https://practicegenius.atlassian.net/browse/PAT-14385
   * */
  if (window.location.pathname === lastRenderedPage) {
    return;
  }

  lastRenderedPage = window.location.pathname;
  mountTargets.forEach(([domSelector, getComponent]) => {
    lazyRender(domSelector, getComponent);
  });
}

/** Init emoji mart with bundled data. It must be done once per page-load so this is the best place to do it for now */
initEmojiMart({data});
lazyMount();

declare const $: any;
declare const prh: any;

$.subscribe(prh.topic.ajaxLoadPageRendered, lazyMount);
